import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from 'providers/AuthProvider';

export default () => {
  const { register } = useAuth();

  const doRegister = React.useCallback(
    async ({ registrationToken, firstName, lastName, password }) => {
      if (!registrationToken) {
        throw new Error('Registration token is required.');
      }

      return register(registrationToken, { firstName, lastName, password });
    },
    [register]
  );

  return useMutation(doRegister);
};
